import type { FileUsageRef, FileVersion } from '@/domain/asset-detail.types'
import { apiClient } from './api.client'

/**
 * Asset Detail's MOCK stand-in endpoints (design §8.10) — version history and
 * usage have no backend anywhere today. Kept separate from the real
 * `file.service.ts` so the mock/real boundary stays obvious at a glance.
 * Applicable-rules moved to `file.service.ts` — it's real now (`build-rule-service`).
 */
const unwrap = <T>(data: { data: T }): T => data.data

export const assetDetailExtrasApi = {
	versions: (fileId: string) =>
		apiClient.get<{ data: FileVersion[] }>(`/files/${fileId}/versions`).then((r) => unwrap(r.data)),
	usage: (fileId: string) =>
		apiClient.get<{ data: FileUsageRef[] }>(`/files/${fileId}/usage`).then((r) => unwrap(r.data)),
}
